import React from 'react';
import { useNavigate } from 'react-router-dom';

const C = {
  dark: '#0a1628',
  white: '#ffffff',
  gray: '#8899aa',
  accent: '#EB1C24',
  border: 'rgba(255,255,255,0.08)',
};

const s = {
  page: { minHeight: '100vh', backgroundColor: C.dark, color: C.white, fontFamily: 'Roboto, sans-serif', padding: '40px 20px' },
  container: { maxWidth: '680px', margin: '0 auto' },
  back: { background: 'none', border: 'none', color: C.gray, cursor: 'pointer', fontSize: '14px', marginBottom: '32px', padding: 0 },
  logo: { fontSize: '22px', fontWeight: 800, color: C.white, marginBottom: '8px', letterSpacing: '2px' },
  title: { fontSize: '28px', fontWeight: 700, marginBottom: '8px' },
  subtitle: { fontSize: '15px', color: C.gray, marginBottom: '40px' },
  section: { marginBottom: '32px' },
  h2: { fontSize: '17px', fontWeight: 700, color: C.white, marginBottom: '12px', paddingBottom: '8px', borderBottom: `1px solid ${C.border}` },
  p: { fontSize: '15px', color: '#ccd6e0', lineHeight: '1.75', marginBottom: '12px' },
  ul: { paddingLeft: '20px', margin: '8px 0 12px' },
  li: { fontSize: '15px', color: '#ccd6e0', lineHeight: '1.75', marginBottom: '4px' },
  box: { backgroundColor: 'rgba(235,28,36,0.1)', border: '1px solid rgba(235,28,36,0.3)', borderRadius: '12px', padding: '20px 24px' },
  link: { color: '#0071BA', textDecoration: 'none' },
};

export default function EliminaDati() {
  const navigate = useNavigate();

  return (
    <div style={s.page}>
      <div style={s.container}>
        <button style={s.back} onClick={() => navigate(-1)}>← Torna indietro</button>

        <div style={s.logo}>OCTA</div>
        <h1 style={s.title}>Eliminazione dei dati utente</h1>
        <p style={s.subtitle}>Istruzioni per richiedere la cancellazione dei tuoi dati personali</p>

        <div style={s.section}>
          <h2 style={s.h2}>Quali dati conserviamo</h2>
          <p style={s.p}>Quando accedi tramite Facebook, OCTA conserva:</p>
          <ul style={s.ul}>
            <li style={s.li}>Il tuo indirizzo email</li>
            <li style={s.li}>Il tuo nome e foto profilo</li>
            <li style={s.li}>Le esperienze di viaggio che hai creato sulla piattaforma</li>
          </ul>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>Come richiedere la cancellazione</h2>
          <p style={s.p}>
            Per richiedere la cancellazione completa del tuo account e di tutti i dati associati, invia una email a:
          </p>
          <div style={s.box}>
            <p style={{ ...s.p, marginBottom: 0, fontWeight: 600, color: C.white }}>
              <a href="mailto:pasquettofederico@hotmail.it" style={s.link}>pasquettofederico@hotmail.it</a>
            </p>
            <p style={{ ...s.p, marginBottom: 0, marginTop: '8px' }}>
              Oggetto: <strong>Richiesta eliminazione dati OCTA</strong>
            </p>
          </div>
        </div>

        <div style={s.section}>
          <h2 style={s.h2}>Tempi di elaborazione</h2>
          <p style={s.p}>
            La tua richiesta verrà elaborata entro <strong>30 giorni</strong>. Riceverai una conferma via email una volta completata la cancellazione.
          </p>
          <p style={s.p}>
            La cancellazione include tutti i dati del profilo, le esperienze create e qualsiasi informazione associata al tuo account.
          </p>
        </div>
      </div>
    </div>
  );
}
